import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Yes",
  cancelText = "No"
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { 
          borderRadius: '4px',
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle 
        id="confirmation-dialog-title"
        sx={{ 
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)', 
          px: 2, 
          py: 1,
          fontSize: '0.95rem',
          fontWeight: 'medium',
          backgroundColor: '#f7f7f7'
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Typography sx={{ fontSize: '0.875rem' }}>{message}</Typography>
      </DialogContent>
      <DialogActions
        sx={{ 
          px: 2, 
          py: 1,
          borderTop: '1px solid rgba(0, 0, 0, 0.08)',
          backgroundColor: '#f7f7f7',
          gap: 1
        }}
      >
        <Button 
          onClick={onClose} 
          color="primary"
          variant="outlined"
          size="small"
          sx={{ 
            borderRadius: '4px',
            textTransform: 'none',
            px: 1.5,
            py: 0.5,
            minWidth: '60px',
            fontSize: '0.8rem'
          }}
        >
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
          size="small"
          sx={{ 
            borderRadius: '4px',
            textTransform: 'none',
            px: 1.5,
            py: 0.5,
            minWidth: '60px',
            fontSize: '0.8rem'
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal; 